class ImageGridLightbox extends HTMLElement {
  constructor() {
    super();
    this.images = [];
    this.currentIndex = 0;
    this.isOpen = false;
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  connectedCallback() {
    this.lightbox = this.querySelector('[data-image-grid-lightbox]');
    this.imageEl = this.querySelector('[data-lightbox-image]');
    this.captionEl = this.querySelector('[data-lightbox-caption]');
    this.counterEl = this.querySelector('[data-lightbox-counter]');
    this.closeBtn = this.querySelector('[data-lightbox-close]');
    this.prevBtn = this.querySelector('[data-lightbox-prev]');
    this.nextBtn = this.querySelector('[data-lightbox-next]');
    this.overlay = this.querySelector('[data-lightbox-overlay]');

    this.collectImages();
    this.bindEvents();
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  collectImages() {
    this.images = Array.from(this.querySelectorAll('[data-lightbox-trigger]')).map((trigger, index) => {
      trigger.dataset.lightboxIndex = String(index);
      return {
        src: trigger.dataset.fullUrl,
        alt: trigger.dataset.alt || '',
        caption: trigger.dataset.caption || '',
      };
    });
  }

  bindEvents() {
    this.querySelectorAll('[data-lightbox-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const index = Number(trigger.dataset.lightboxIndex || 0);
        this.open(index);
      });
    });

    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());
  }

  open(index) {
    if (!this.images.length) return;

    this.collectImages();
    this.currentIndex = index;
    this.isOpen = true;
    this.render();
    this.lightbox?.removeAttribute('hidden');
    this.lightbox?.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('image-grid-lightbox-open');
    document.addEventListener('keydown', this.onKeyDown);
    this.closeBtn?.focus();
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.lightbox?.setAttribute('hidden', '');
    this.lightbox?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('image-grid-lightbox-open');
    document.removeEventListener('keydown', this.onKeyDown);
  }

  prev() {
    if (!this.images.length) return;
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.render();
  }

  next() {
    if (!this.images.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.render();
  }

  render() {
    const item = this.images[this.currentIndex];
    if (!item || !this.imageEl) return;

    this.imageEl.src = item.src;
    this.imageEl.alt = item.alt;

    if (this.captionEl) {
      if (item.caption) {
        this.captionEl.textContent = item.caption;
        this.captionEl.removeAttribute('hidden');
      } else {
        this.captionEl.textContent = '';
        this.captionEl.setAttribute('hidden', '');
      }
    }

    if (this.counterEl) {
      this.counterEl.textContent = `${this.currentIndex + 1} / ${this.images.length}`;
    }

    const multi = this.images.length > 1;
    this.prevBtn?.toggleAttribute('hidden', !multi);
    this.nextBtn?.toggleAttribute('hidden', !multi);
  }

  onKeyDown(event) {
    if (!this.isOpen) return;

    if (event.key === 'Escape') {
      this.close();
    } else if (event.key === 'ArrowLeft') {
      this.prev();
    } else if (event.key === 'ArrowRight') {
      this.next();
    }
  }
}

customElements.define('image-grid-lightbox', ImageGridLightbox);
